import { render } from "./areaadd.vue?vue&type=template&id=35b35c27&scoped=true&ts=true"
import script from "./areaadd.vue?vue&type=script&lang=ts"
export * from "./areaadd.vue?vue&type=script&lang=ts"

import "./areaadd.vue?vue&type=style&index=0&id=35b35c27&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b35c27"]])

export default __exports__